import React from 'react';
import { Avatar, Grid, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';
import { makeEmployeeLabel } from 'utils/employee.utils';

interface IProps {
  firstName: string;
  lastName: string;
  employee?: IEmployeeBasicInfo;
  photoUrl?: string;
  small?: boolean;
}

const StyledAvatar = styled(Avatar)({
  width: 16,
  height: 16,
});

const SalespersonName = ({ firstName, lastName, employee, photoUrl, small }: IProps) => {
  const color = small ? 'textSecondary' : 'initial';
  const variant = small ? 'body2' : 'body1';
  let title: string;

  if (small) {
    title = `${firstName[0]}.${lastName}`;
  } else {
    title = employee ? makeEmployeeLabel(employee) : `${firstName} ${lastName}`;
  }

  return (
    <Grid container wrap="nowrap" alignItems="center" spacing={1}>
      {small && (
        <Grid item>
          <StyledAvatar alt={firstName} src={photoUrl} variant="circular" />
        </Grid>
      )}

      <Grid item>
        <Typography variant={variant} color={color}>
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default React.memo(SalespersonName);
